import neighborhoodSmartMappingDefinition, {
  recommendedSmartMappingOptions,
} from '../smartMapping/neighborhoodSmartMapping.definition'
import neighborhoodEditCoverageAreaDefinition from './neighborhoodEditCoverageArea.definition'
import neighborhoodFetchDefinition from '../fetch/neighborhoodFetch.definition'
import { MultiPolygon, Polygon } from 'geojson'
import { EditCoverageArea, ItemContentWrapper } from '~/components/editCoverageArea'
import { useCallback } from 'react'
import useAPI from '~/prix/react/hooks/api'

interface NeighborhoodOrCommunity {
  key: string
  id: number
  name: string
  kind:
    | 'smartMapping'
    | 'deprecated'
    | 'manualDrawing'
    | 'authorityProvided'
    | 'openStreetMapSourced'
  alternativeNames: string[]
  isCommunity: boolean
  coverageArea: Polygon | MultiPolygon
  municipalityId: number
}

const EditCoverageAreaScreen = EditCoverageArea<
  NeighborhoodOrCommunity,
  typeof neighborhoodFetchDefinition.input,
  typeof neighborhoodFetchDefinition.output,
  typeof neighborhoodEditCoverageAreaDefinition.input,
  typeof neighborhoodEditCoverageAreaDefinition.output,
  typeof neighborhoodSmartMappingDefinition.input,
  typeof neighborhoodSmartMappingDefinition.output
>

export default function NeighborhoodEditCoverageAreaScreen() {
  const api = useAPI()
  console.log('NeighborhoodEditCoverageAreaScreen', { api })

  const renderItemContent = useCallback(
    (item: NeighborhoodOrCommunity, onChange: (item: NeighborhoodOrCommunity) => void) => {
      return (
        <ItemContentWrapper>
          <label>
            <input
              type='checkbox'
              checked={item.isCommunity}
              onChange={event => onChange({ ...item, isCommunity: event.target.checked })}
            />{' '}
            Comunidade
          </label>
        </ItemContentWrapper>
      )
    },
    [],
  )

  return (
    <EditCoverageAreaScreen
      editCoverageAreaDefinition={neighborhoodEditCoverageAreaDefinition}
      fetchDefinition={neighborhoodFetchDefinition}
      smartMappingDefinition={neighborhoodSmartMappingDefinition}
      recommendedSmartMappingOptions={recommendedSmartMappingOptions}
      renderItemContent={renderItemContent}
    />
  )
}
